import React from 'react';

const PageViewIcon = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
    <g id="click-on-icon" fillRule="nonzero">
      <path
        // eslint-disable-next-line
        d="M8,3 C4.81818182,3 2.10090909,5.07333333 1,8 C2.10090909,10.9266667 4.81818182,13 8,13 C11.1818182,13 13.8990909,10.9266667 15,8 C13.8990909,5.07333333 11.1818182,3 8,3 L8,3 Z M8,11.3333333 C6.24363636,11.3333333 4.81818182,9.84 4.81818182,8 C4.81818182,6.16 6.24363636,4.66666667 8,4.66666667 C9.75636364,4.66666667 11.1818182,6.16 11.1818182,8 C11.1818182,9.84 9.75636364,11.3333333 8,11.3333333 L8,11.3333333 Z M8,6 C6.94363636,6 6.09090909,6.89333333 6.09090909,8 C6.09090909,9.10666667 6.94363636,10 8,10 C9.05636364,10 9.90909091,9.10666667 9.90909091,8 C9.90909091,6.89333333 9.05636364,6 8,6 L8,6 Z"
        id="Shape"
        fillRule="nonzero">
      </path>
    </g>
  </svg>
);

export default PageViewIcon;



/** WEBPACK FOOTER **
 ** ./src/views/BaseElements/PageViewIcon.js
 **/